// import React from "react";
// import { motion } from "framer-motion";
// import { ShieldCheck, Truck, RefreshCw, Nut } from "lucide-react";

// const TRUST_BADGES = [
//     {
//         icon: <ShieldCheck size={22} strokeWidth={1.8} />,
//         title: "Secure Payment",
//         description: "100% encrypted checkout. UPI, Cards & COD available.",
//     },
//     {
//         icon: <Nut size={22} strokeWidth={1.8} />,
//         title: "Farm Fresh Quality",
//         description: "Directly sourced from trusted organic farms.",
//     },
//     {
//         icon: <Truck size={22} strokeWidth={1.8} />,
//         title: "Pan-India Shipping",
//         description: "Fast and reliable doorstep delivery nationwide.",
//     },
//     {
//         icon: <RefreshCw size={22} strokeWidth={1.8} />,
//         title: "Easy Returns",
//         description: "Hassle-free 7-day exchange and return policy.",
//     },
// ];

// const Badges = () => {
//     return (
//         <section className="relative py-3 sm:py-6 bg-transparent overflow-hidden">
//             <style>{`
//         .tb-card {
//           background: linear-gradient(135deg, var(--bg-light-panel, #ffffff) 0%, rgba(255, 255, 255, 0.8) 100%);
//           border: 1px solid rgba(var(--color-accent-gold-rgb, 212, 175, 55), 0.25);
//           padding: 16px 14px;
//           border-radius: 14px;
//           box-shadow: 0 4px 20px -2px rgba(0, 0, 0, 0.03);
//           transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           text-align: center;
//           position: relative;
//           backdrop-filter: blur(8px);
//         }
//         .tb-card::after {
//           content: '';
//           position: absolute;
//           inset: 0;
//           border-radius: 14px;
//           border: 1px solid var(--color-primary);
//           opacity: 0;
//           transition: opacity 0.35s ease;
//           pointer-events: none;
//         }
//         .tb-card:hover {
//           transform: translateY(-4px);
//           box-shadow: 0 12px 25px -5px rgba(0, 0, 0, 0.08);
//         }
//         .tb-card:hover::after {
//           opacity: 0.5;
//         }
//         .tb-icon-circle {
//           width: 48px;
//           height: 48px;
//           flex-shrink: 0;
//           border-radius: 12px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: var(--color-bg-alt, #faf6ee);
//           border: 1px solid rgba(var(--color-accent-gold-rgb, 212, 175, 55), 0.3);
//           color: var(--color-accent-gold, #d4af37);
//           transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
//           margin-bottom: 10px;
//         }
//         .tb-card:hover .tb-icon-circle {
//           background: var(--color-primary);
//           border-color: var(--color-primary);
//           color: #fff;
//           transform: scale(1.08) rotate(-3deg);
//           box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
//         }
//         .tb-title {
//           font-family: var(--font-heading);
//           font-weight: 600;
//           font-size: clamp(0.85rem, 1.8vw, 1rem);
//           color: var(--color-text-primary);
//           letter-spacing: 0.03rem;
//           margin-bottom: 2px;
//           line-height: 1.2;
//         }
//         .tb-desc {
//           font-family: var(--font-body, inherit);
//           font-size: 0.775rem;
//           line-height: 1.35;
//           color: var(--color-text-secondary);
//           opacity: 0.85;
//         }
//       `}</style>

//             <div className="container mx-auto px-3 sm:px-6 lg:px-10   pt-3  pb-3">
//                 <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
//                     {TRUST_BADGES.map((item, index) => (
//                         <motion.div
//                             key={item.title}
//                             initial={{ opacity: 0, y: 15 }}
//                             whileInView={{ opacity: 1, y: 0 }}
//                             viewport={{ once: true }}
//                             transition={{ duration: 0.4, delay: index * 0.08 }}
//                             className="tb-card cursor-default"
//                         >
//                             <div className="tb-icon-circle">{item.icon}</div>
//                             <div className="flex flex-col items-center">
//                                 <h3 className="tb-title">{item.title}</h3>
//                                 <p className="tb-desc">{item.description}</p>
//                             </div>
//                         </motion.div>
//                     ))}
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default Badges;




import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Truck, RefreshCw, Nut } from "lucide-react";

const TRUST_BADGES = [
    {
        icon: <ShieldCheck size={22} strokeWidth={1.8} />,
        title: "Secure Payment",
        description: "100% encrypted checkout. UPI, Cards & COD available.",
    },
    {
        icon: <Nut size={22} strokeWidth={1.8} />,
        title: "Farm Fresh Quality",
        description: "Directly sourced from trusted organic farms.",
    },
    {
        icon: <Truck size={22} strokeWidth={1.8} />,
        title: "Pan-India Shipping",
        description: "Fast and reliable doorstep delivery nationwide.",
    },
    {
        icon: <RefreshCw size={22} strokeWidth={1.8} />,
        title: "Easy Returns",
        description: "Hassle-free 7-day exchange and return policy.",
    },
];

const Badges = () => {
    return (
        <section className="relative py-3 sm:py-6 bg-transparent overflow-hidden">
            <style>{`
        .tb-card {
          background: transparent;
          border: 1px solid rgba(var(--color-accent-gold-rgb, 212, 175, 55), 0.25);
          padding: 16px 14px;
          border-radius: 14px;
          box-shadow: 0 4px 20px -2px rgba(0, 0, 0, 0.03);
          transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          position: relative;
          backdrop-filter: blur(8px);
        }
        .tb-card::after {
          content: '';
          position: absolute;
          inset: 0;
          border-radius: 14px;
          border: 1px solid var(--color-primary);
          opacity: 0;
          transition: opacity 0.35s ease;
          pointer-events: none;
        }
        .tb-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 25px -5px rgba(0, 0, 0, 0.08);
        }
        .tb-card:hover::after {
          opacity: 0.5;
        }
        .tb-icon-circle {
          width: 48px;
          height: 48px;
          flex-shrink: 0;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--color-bg-alt, #faf6ee);
          border: 1px solid rgba(var(--color-accent-gold-rgb, 212, 175, 55), 0.3);
          color: var(--color-accent-gold, #d4af37);
          transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
          margin-bottom: 10px;
        }
        .tb-card:hover .tb-icon-circle {
          background: var(--color-primary);
          border-color: var(--color-primary);
          color: #fff;
          transform: scale(1.08) rotate(-3deg);
          box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
        }
        .tb-title {
          font-family: var(--font-heading);
          font-weight: 600;
          font-size: clamp(0.85rem, 1.8vw, 1rem);
          color: var(--color-text-primary);
          letter-spacing: 0.03rem;
          margin-bottom: 2px;
          line-height: 1.2;
        }
        .tb-desc {
          font-family: var(--font-body, inherit);
          font-size: 0.775rem;
          line-height: 1.35;
          color: var(--color-text-secondary);
          opacity: 0.85;
        }
      `}</style>

            <div className="container mx-auto px-3 sm:px-6 lg:px-10   pt-3  pb-3">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
                    {TRUST_BADGES.map((item, index) => (
                        <motion.div
                            key={item.title}
                            initial={{ opacity: 0, y: 15 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.4, delay: index * 0.08 }}
                            className="tb-card cursor-default"
                        >
                            <div className="tb-icon-circle">{item.icon}</div>
                            <div className="flex flex-col items-center">
                                <h3 className="tb-title">{item.title}</h3>
                                <p className="tb-desc">{item.description}</p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Badges;